import React, { useState } from "react";
import { makeRequestAuth } from "../../_config/api";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import { FiX, FiEdit } from "react-icons/fi";

export default function EditSubjectModal({ data, onClose, onSuccess }) {
  const [name, setName] = useState(data?.name || "");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      showErrorToast("Subject name is required");
      return;
    }

    try {
      setLoading(true);
      // API Call for Update
      await makeRequestAuth("post", "/admin/updateSubject", {
        subjectId: data._id,
        name: name,
      });

      showSuccessToast("Subject updated successfully");
      onSuccess(); // Close modal & refresh list
    } catch (error) {
      showErrorToast(
        error?.response?.data?.message || "Failed to update subject",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm transition-all">
      <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
        {/* HEADER */}
        <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50">
          <div className="flex items-center gap-2">
            <div className="bg-blue-100 p-2 rounded-lg text-blue-600">
              <FiEdit size={20} />
            </div>
            <h3 className="text-lg font-bold text-gray-800">Edit Subject</h3>
          </div>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-200 text-gray-500 transition"
          >
            <FiX size={20} />
          </button>
        </div>

        {/* BODY */}
        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Subject Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Physics"
              className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none transition-all"
            />
          </div>

          {/* FOOTER ACTIONS */}
          <div className="flex flex-col sm:flex-row gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="order-2 sm:order-1 flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="order-1 sm:order-2 flex-1 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-lg shadow-blue-500/30 font-medium disabled:opacity-50 transition-all"
            >
              {loading ? "Updating..." : "Update Subject"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
